import { render, staticRenderFns } from "./MhlvTable.vue?vue&type=template&id=9878d0ac"
import script from "./MhlvTable.vue?vue&type=script&lang=js"
export * from "./MhlvTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports